import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c80a296"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header_top" }
const _hoisted_2 = { class: "header_top_inner" }
const _hoisted_3 = { class: "header_top_inner_logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "header_top_inner_info" }
const _hoisted_6 = {
  key: 0,
  class: "l_userinfo"
}
const _hoisted_7 = { class: "userinfo" }
const _hoisted_8 = { class: "userinfo_icon" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "userinfo_name" }
const _hoisted_11 = { class: "userinfo_btn" }
const _hoisted_12 = { class: "userinfo_btn_logout" }

import { computed, inject, Ref } from 'vue'
import { useRoute } from 'vue-router'
import AuthHelper from '@/helpers/AuthHelper'
import config from '@/config/config'
import { usePortalStore } from '@/store/index'
import { injectionKeys } from '@/constants/injectionKeys'
import { errorPageNames } from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  emits: ['click:logout'],
  setup(__props, { emit }) {

const route = useRoute()
const portal = usePortalStore()


const isUserId = inject<Ref<boolean>>(injectionKeys.isUserId)!

// 404,500,503エラー判定
const isErrorPage = computed(() => {
  return typeof route.name === 'string' && errorPageNames.includes(route.name)
})

const userIcon = computed(() => {
  const icon = portal.getUser?.profileImageType
  return icon || 1
})

// ログアウト
const logout = async () => {
  emit('click:logout')
}

const displayNickname = computed(() => {
  const nickname = portal.getUser?.displayName ?? ''
  return (
    nickname.slice(0, 25) +
    (nickname.length > 25 ? '...' : '') +
    (isUserId.value ? 'さん' : '')
  )
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: {
            name: 'ExternalLink',
            params: { href: _unref(config).mottosokkaUrl },
          }
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: 
              require(`@/assets/design/image/logo_mottosokka02_${_unref(config).env}.svg`)
            ,
              alt: "MottoSokka!"
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!_unref(isErrorPage))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_unref(isUserId))
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: {
                  name: 'ExternalLink',
                  params: {
                    href: _unref(config).mottosokkaUrl + '/my_page?type=Yomokka',
                  },
                }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: 
                    require(`@/assets/design/icon/profile/icon_profile${_unref(userIcon)}.svg`)
                  ,
                            alt: "ユーザーアイコン"
                          }, null, 8, _hoisted_9)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(_unref(displayNickname)), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    (_unref(AuthHelper).isLogin())
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: logout
                        }, "ログアウト"))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})